import { render, staticRenderFns } from "./ResetPasswordView.vue?vue&type=template&id=fa4c84ea&scoped=true"
import script from "./ResetPasswordView.vue?vue&type=script&lang=js"
export * from "./ResetPasswordView.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordView.vue?vue&type=style&index=0&id=fa4c84ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4c84ea",
  null
  
)

export default component.exports